import { mapActions, mapGetters } from 'vuex'
import { filter } from 'lodash'

export default {
  data () {
    return {
      areaIndex: [],
      queries: [],
      isLoading: false,
      drawer: null,
      isMiniDrawer: false,
      querySearch: ''
    }
  },
  mounted () {
    this.getQueries()
  },
  computed: {
    ...mapGetters([
      'getterQueries',
      'getterSelectedQuery',
      'getterAccount'
    ]),
    filteredList () {
      if (this.querySearch) {
        if (filter(this.getterQueries, (database) => database.name.toLowerCase().includes(this.querySearch.toLowerCase())).length > 0) {
          return filter(this.getterQueries, (database) => database.name.toLowerCase().includes(this.querySearch.toLowerCase()))
        } else {
          let databaseQuerySelected = []

          this.getterQueries.map((database) => {
            if (filter(database.queries, (query) => query.description.toLowerCase().includes(this.querySearch.toLowerCase())).length > 0) {
              databaseQuerySelected.push({
                ...database,
                queries: filter(database.queries, (query) => query.description.toLowerCase().includes(this.querySearch.toLowerCase()))
              })

              return databaseQuerySelected
            }
          })
          return databaseQuerySelected
        }
      } else {
        return this.getterQueries
      }
    }
  },
  methods: {
    ...mapActions([
      'actionGetQueries'
    ]),
    getQueries () {
      this.isLoading = true

      this.actionGetQueries()
        .then(() => {
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
    },
    emitQuery (query) {
      this.$emit('selected-query', query)
    }
  }
}
